import { Link } from "react-router-dom";

const relatedArticles = [
  {
    id: 1,
    title: "Best Beige Sofas for a Calm Living Room",
    category: "Living Rooms",
    path: "/living-room/soft-beige#similar-beige-sofas",
    image: "https://public.readdy.ai/ai/img_res/a9bc600538dc1cace3f793e28a577fa6.jpg",
  },
  {
    id: 2,
    title: "Neutral Rugs That Make a Room Look Expensive",
    category: "Living Rooms",
    path: "/living-room/soft-beige#similar-neutral-rugs",
    image: "https://readdy.ai/api/search-image?query=neutral%20area%20rug%20living%20room%20warm%20ivory%20wool%20texture%20floor%20detail%20calm%20interior%20editorial%20photography%20beautiful%20expensive%20looking&width=640&height=480&seq=rel_sb2&orientation=landscape",
  },
  {
    id: 3,
    title: "Best Linen Curtains for Soft Beige Rooms",
    category: "Living Rooms",
    path: "/living-room/soft-beige#similar-linen-curtains",
    image: "https://readdy.ai/api/search-image?query=linen%20curtains%20soft%20beige%20room%20sheer%20natural%20light%20window%20treatment%20cream%20ivory%20warm%20neutral%20interior%20editorial%20photography%20calm%20beautiful&width=640&height=480&seq=rel_sb3&orientation=landscape",
  },
  {
    id: 4,
    title: "Beige Living Room Look for Less",
    category: "Living Rooms",
    path: "/living-room/soft-beige#look-for-less",
    image: "https://readdy.ai/api/search-image?query=affordable%20beige%20living%20room%20budget%20neutral%20interior%20warm%20calm%20cozy%20cream%20sofa%20rug%20curtains%20editorial%20photography%20beautiful%20serene&width=640&height=480&seq=rel_sb4&orientation=landscape",
  },
  {
    id: 5,
    title: "Small Apartment, Soft Neutrals",
    category: "Living Rooms",
    path: "/living-room/small-apartment-soft-neutrals",
    image: "https://readdy.ai/api/search-image?query=small%20apartment%20living%20room%20soft%20neutral%20palette%20cream%20beige%20warm%20ivory%20minimal%20furniture%20natural%20light%20linen%20sofa%20compact%20elegant%20editorial%20interior%20photography%20serene%20calm%20atmosphere&width=640&height=480&seq=rel_sb5&orientation=landscape",
  },
];

export default function ArticleRelated() {
  return (
    <section className="py-20 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="mb-12">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Continue Reading
          </p>
          <h2
            className="text-[#2C2825] text-3xl md:text-4xl"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            More calm spaces to explore
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {relatedArticles.map((article) => (
            <Link key={article.id} to={article.path} className="group cursor-pointer block">
              <div className="relative overflow-hidden rounded-xl bg-[#EDE6DA] aspect-[4/3] mb-4">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                <div className="absolute top-3 left-3">
                  <span
                    className="bg-[#FAF7F0]/90 text-[#6B5E53] text-[9px] px-2.5 py-1 rounded-full tracking-wider"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {article.category}
                  </span>
                </div>
              </div>
              <h3
                className="text-[#2C2825] text-sm leading-snug group-hover:text-[#6B5E53] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {article.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
